/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Jobticket_Cancel_PastInputs */



/**

* @param {Validation_Jobticket_Cancel_PastInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const validation_jobticket_cancel_past = /** @type {((inputs?: Validation_Jobticket_Cancel_PastInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Jobticket_Cancel_PastInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Das Kündigungsdatum darf nicht in der Vergangenheit sein.")
});